export default __webpack_public_path__ + "static/media/slide21.472b478d.png";